import type { JobArchitectureGenerationInfo } from '~/shared/data-contract/job-architecture';

type GenerationState = 'failed' | 'finished' | 'queued' | 'started' | null | undefined;

export const isPendingGenerationState = (state: GenerationState): boolean => state === 'queued' || state === 'started';

export const isTranslating = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean =>
    isPendingGenerationState(generationInfo?.translationState);

export const isDetectingSkills = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean =>
    isPendingGenerationState(generationInfo?.skillDetectionState);

export const isMainGenerationInProgress = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean =>
    generationInfo?.inProgress === true;

export const isGenerationInProgress = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean =>
    isMainGenerationInProgress(generationInfo) || isTranslating(generationInfo) || isDetectingSkills(generationInfo);
